export default __webpack_public_path__ + "static/media/i-attention-red.fe45a036.svg";